import { chartStyles } from "../../styles"
import { Checkbox } from "@material-ui/core"
import { LegendItemRootLayout } from "./DetailsLayout/FiltersChartLayout/LegendItemRootLayout"

export function LegendItemCheckbox({
  value,
  color,
  keyIndex,
  onChange,
  availableEntities,
}: {
  value: string
  color: string
  keyIndex: number
  onChange: (idx: number, entity: string) => void
  availableEntities: string[]
}) {
  return (
    <LegendItemRootLayout title={value} color={color} selectAll={false}>
      <Checkbox
        id={"checkbox"}
        checked={availableEntities.includes(value)}
        color="primary"
        key={keyIndex}
        value={value}
        className={chartStyles.button}
        style={{ padding: 0 }}
        onClick={() => onChange(keyIndex, value)}
      />
    </LegendItemRootLayout>
  )
}
